module.exports = __webpack_public_path__ + "static/media/acquisition-lady.8b12651d.png";